import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

type PublishOpportunitySuccessModalProps = {
  open: boolean
  handleClose: VoidFunction
}

export function PublishOpportunitySuccessModal({ open, handleClose }: Readonly<PublishOpportunitySuccessModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="publish-opportunity-success"
      data-testid="publish-opportunity-success-modal"
    >
      <AcknowledgeModal
        result="positive"
        title={t('dialog.volunteering.publish.success.title')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="publish-success-modal-btn"
      >
        {t('dialog.volunteering.publish.success.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
